import $ from 'jquery'
import React, { useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { popupOpenClose } from "../../../action/action";
import { DayPicker } from 'react-day-picker';
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import 'react-day-picker/dist/style.css';

const ResReservation3a = (props) => {

    const { t } = props
    const maxDate = new Date(props.checkoutDate)
    maxDate.setDate(maxDate.getDate() - 1);
    
    const [date, setDate] = useState(null);
    const [formatedDate, setFormatedDate] = useState(null);
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [servingPeriodId, setServingPeriodId] = useState(null);

    const [renderDate, setRenderDate] = useState(false);

    const css = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }
    `

    const handleSelectDate = (selectedDate) => {
        if (!selectedDate) {
            setDate(null);
            setFormatedDate(null);
        } else {

            setRenderDate(false);
            setDate(selectedDate);

            // converting to local date string
            const year = selectedDate.getFullYear();
            const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
            const day = String(selectedDate.getDate()).padStart(2, '0');

            const localDateString = `${year}-${month}-${day}`;

            setFormatedDate(new Date(localDateString).toISOString());
        }
    }

    const handleShowAvailablity = () => {

        if (!formatedDate) {
            props.popupOpenClose(true, t('resReservation.missing.missing_date'))
            return;
        }

        if (!servingPeriodId) {
            props.popupOpenClose(true, t('resReservation.missing.missing_service_period'))
            return;
        }

        if(adults + children == 0){
            props.popupOpenClose(true, t('resReservation.missing.missing_people'))
            return;
        }

        const payload = {
            "createReservationBody": {
                "servingPeriodId": servingPeriodId,
                "dateTime": formatedDate,
                "reservationDetails": [{
                    "adults": adults,
                    "children": children,
                }]
            }
        }

        props.next(payload)
    }

    React.useEffect(() => {

        if(renderDate){
            $(".overlay").attr('style', 'background: none !important');
            $("body").addClass("overlay-cast");
        } else {
            $(".overlay").attr('style', '');
            $("body").removeClass("overlay-cast");
        }

    },[renderDate])

    React.useEffect(() => {
        if (props.createReservationData.createReservationBody.dateTime) {
            setDate( new Date(props.createReservationData.createReservationBody.dateTime) )
            setFormatedDate(props.createReservationData.createReservationBody.dateTime)
        }

        props.createReservationData.createReservationBody.reservationDetails[0] && props.createReservationData.createReservationBody.reservationDetails[0].adults >= 0 && setAdults(+props.createReservationData.createReservationBody.reservationDetails[0].adults)
        props.createReservationData.createReservationBody.reservationDetails[0] && props.createReservationData.createReservationBody.reservationDetails[0].children && setChildren(+props.createReservationData.createReservationBody.reservationDetails[0].children)
        props.createReservationData.createReservationBody.servingPeriodId && setServingPeriodId(props.createReservationData.createReservationBody.servingPeriodId)

    }, [])


    return (
        <>
            <section class="widgets">
                <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                    <h2>{props.subHeading}</h2>
                </div>
                <div class="form-window">
                    <div class="form-window-heading">{t('resReservation.res_details')}</div>
                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1" style={{ borderColor: "#ccc" }}>
                        <div class="form-row">
                            <label for="reservationDate">{t('resReservation.res_date')} <span style={{ color: "red" }}>*</span></label>
                            {/* <input disabled={props.updatingCustomerDetails} type="date" name="reservationDate" id="reservationDate" value={date} onChange={(e) => { console.log(e.target.value); setDate(e.target.value); setFormatedDate(new Date(e.target.value).toISOString()) }} min={new Date().toISOString().split('T')[0]} max={maxDate.toISOString().split('T')[0]} /> */}
                            <input disabled={props.updatingCustomerDetails} type="button" value={formatedDate ? dateFormatHandler(formatedDate, props.dateFormat) : "Select Date"} onClick={() => setRenderDate(!renderDate)} />
                        </div>
                        <div class="form-row">
                            <label for="adultCounter">{t('resReservation.res_adults')} <span style={{ color: "red" }}>*</span></label>
                            <div class="item-qty">
                                <button disabled={adults <= 0 ? true : false} onClick={() => setAdults(adults - 1)} >-</button>
                                <input type="number" name="adultCount" value={adults} onChange={(e) => setAdults(e.target.value)} />
                                <button onClick={() => setAdults(adults + 1)}>+</button>
                            </div>
                        </div>
                        <div class="form-row">
                            <label for="childCounter">{t('resReservation.res_children')} <span style={{ color: "red" }}>*</span></label>
                            <div class="item-qty">
                                <button disabled={children <= 0 ? true : false} onClick={() => setChildren(children - 1)}>-</button>
                                <input type="number" name="childCount" value={children} onChange={(e) => setChildren(e.target.value)} />
                                <button onClick={() => setChildren(children + 1)}>+</button>
                            </div>
                        </div>
                        <div class="form-row">
                            <label for="childCounter">{t('resReservation.res_serving_period')} <span style={{ color: "red" }}>*</span></label>
                            <select disabled={props.updatingCustomerDetails} name="childCounter" id="childCounter" value={servingPeriodId} onChange={(e) => setServingPeriodId(e.target.value)}>
                                <option value="">{t('resReservation.select_serving_period_0')}</option>
                                {props.servingPeriodsList.map((list) => (
                                    <option value={list.id}>{list.description}</option>
                                ))}
                            </select>
                        </div>
                        {t('resReservation.reservation_note', { defaultValue: null }) && <div class="form-row">
						    <p>{t('resReservation.reservation_note')}</p>
					    </div>}
                    </div>
                    <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        <div class="form-controls">
                            <button class="primary w-100 margin-bottom-1" onClick={() => handleShowAvailablity()}>{t('resReservation.show_avail_time')}</button>
                            <button class="secondary w-100" onClick={() => props.close()} >{t('resReservation.close')}</button>
                        </div>
                    </div>
                </div>
                { renderDate && 
                <div className="overlay" onClick={() => setRenderDate(false)}>
                    <div onClick={(event) => {event.stopPropagation()}} class="overlay-date">
                        <style>{css}</style>
                        <DayPicker
                            mode="single"
                            selected={date}
                            onSelect={(selectedDate) => handleSelectDate(selectedDate)}
                            disabled={{
                                before: new Date(),
                                after: maxDate
                            }}
                        />
                    </div>
                </div>
                }
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        menuColor: state.store.home.MenuColor,
        dateFormat: state.store.home.clientConfig.extraConfigParam ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
    }
}

export default connect(mapStateToProps, { popupOpenClose })(withTranslation('translations')(ResReservation3a));